export const apiUrl = import.meta.env.VITE_DJANGO_URL;

export const authHeaders = (): HeadersInit => {
  const token = localStorage.getItem('token');
  if (!token) {
    return {
      'Content-Type': 'application/json',
    };
  }
  return {
    'Content-Type': 'application/json',
    Authorization: 'Token ' + token,
  };
};

//
// ─── AUTHENTICATION ─────────────────────────────────────────────────────────────
//

export const userLogin = async (username, password) => {
  try {
    const resp = await fetch(apiUrl + '/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const json = await resp.json();
    localStorage.setItem('token', json.token);
    if (json.expiry) {
      localStorage.setItem('expiry', json.expiry);
      const ttl = new Date(json.expiry).getTime() - Date.now();
      localStorage.setItem('sessionTTL', ttl.toString());
    }
    return json;
  } catch (error) {
    return error;
  }
};

export const getUser = async () => {
  try {
    const resp = await fetch(apiUrl + '/auth/user', {
      headers: authHeaders(),
    });
    if (resp.status === 401) {
      window.dispatchEvent(new Event('session-expired'));
      return { error: 'Unauthorized' };
    }
    const json = await resp.json();
    // Signal session activity on successful authenticated response
    window.dispatchEvent(new Event('session-activity'));
    return json;
  } catch (error) {
    return error;
  }
};
